import * as Contract from '../SharedApiExternalContract';

import { DataSourceImpl } from './Impl/DataSourceImpl';

export class DataSource implements Contract.DataSource {
  public constructor(private _dataSourceImpl: DataSourceImpl) { }

  public get name(): string {
    return this._dataSourceImpl.name;
  }

  public get id(): string {
    return this._dataSourceImpl.id;
  }

  public get fields(): Array<Contract.Field> {
    return this._dataSourceImpl.fields;
  }

  public get extractUpdateTime(): string | undefined {
    return this._dataSourceImpl.extractUpdateTime;
  }

  public get isExtract(): boolean {
    return this._dataSourceImpl.isExtract;
  }

  public refreshAsync(): Promise<void> {
    return this._dataSourceImpl.refreshAsync();
  }

  public getActiveTablesAsync(): Promise<Array<Contract.TableSummary>> {
    return this._dataSourceImpl.getActiveTablesAsync();
  }

  public getConnectionSummariesAsync(): Promise<Array<Contract.ConnectionSummary>> {
    return this._dataSourceImpl.getConnectionSummariesAsync();
  }

  public getUnderlyingDataAsync(options?: Contract.DataSourceUnderlyingDataOptions):
    Promise<Contract.DataTable> {
    return this._dataSourceImpl.getUnderlyingDataAsync(options);
  }
}



// WEBPACK FOOTER //
// ../../../src/ApiShared/DataSource.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/DataSource.ts